import React from 'react';
import { useNavigate } from 'react-router-dom';

//Components
import { DataGrid, ViewButton, CreateFab, FabContainer } from '@arredo/reactjs-ui';
import ArchingFilters from './filters';

//Material UI
import { Paper, Typography, Grid, Box } from '@mui/material';

//Hooks
import useArchings from '../../hooks/archings/useArchings';
import useAuthorize from '../../hooks/user/useAuthorize';

// Models
import { title, columns } from '../../models/ArchingEntity';
import { Permissions } from '../../models/Roles';

const Arching = () => {
    const isAuthorized = useAuthorize();
    const push = useNavigate()
    const { archings, filters, setParameterSearch, totalPage, clearFilters, loading } = useArchings();
    const handleChangePage = (e, page) =>
        setParameterSearch({
            ...filters,
            pageNumber: Number(page)
        });

    return (
        <>
            <Grid container spacing={1}>
                <Grid size="grow">
                    <Box component={Paper} padding={2}>
                        <Typography variant="h4">
                            {title}
                        </Typography>
                    </Box>
                </Grid>
                <Grid size={12}>
                    <ArchingFilters
                        filters={filters}
                        setFilters={setParameterSearch}
                        clearFilters={clearFilters}
                    />
                </Grid>
                <Grid size={12}>
                    <DataGrid
                        columns={columns}
                        rows={archings}
                        loading={loading}
                        actions={({ row }) => (
                            <>
                                {isAuthorized([Permissions.CashregisterView]) && (
                                    <ViewButton
                                        to={
                                            row.closureId
                                                ? `/cashRegisters/closures/${row.closureId}`
                                                : `/cashRegisters/archings/detail/${row.id}`
                                        }
                                    />
                                )}
                            </>
                        )}
                        paginationProps={{
                            count: totalPage,
                            page: filters?.pageNumber || 1,
                            onChange: handleChangePage
                        }}
                    />
                </Grid>
            </Grid>
            <FabContainer>
                {isAuthorized([Permissions.CashregisterView]) && <CreateFab onClick={() => push(`/cashRegisters/archings/create`)} />}
            </FabContainer>
        </>
    );
}

export default Arching;